import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'; // Use useParams to get the URL parameter
import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import { AnimatePresence, motion } from 'framer-motion';
import useContentful from './useContentful.js'
import { QRCodeSVG } from 'qrcode.react';
import ReactGA from "react-ga4";
import { useHistory } from 'react-router-dom';
import { FacebookProvider, CustomChat } from 'react-facebook';
import Modal from './modal.js';
import './styles/home.scss'

import dp from '../assets/img/jins.jpg'
import cover from '../assets/img/logo.png'
import bpi from '../assets/img/bpi.png'
import gcash from '../assets/img/gcash.png'
import maya from '../assets/img/maya.png'
import metrobank from '../assets/img/metrobank.png'

// Initialize ReactGA with your Measurement ID
ReactGA.initialize('G-XTZKVXPQJC');

function Home(themeData) {

  const history = useHistory();

  // set page title
  useEffect(() => {
    document.title = 'Account Settings • quickLink';;
  }, []);

  // animating divs
  // update card info
  const [isVisible1, setIsVisible1] = useState(false);
  const toggleVisibility1 = () => {
    setIsVisible1(!isVisible1);
  };
  // deactivate card info
  const [isVisible2, setIsVisible2] = useState(false);
  const toggleVisibility2 = () => {
    setIsVisible2(!isVisible2);
  };

  // configure modal
  // gcash modal
  const [isOpenGcash, setIsOpenGcash] = useState(false);
  const openModalGcash = () => {
    setIsOpenGcash(true);
  };
  const closeModalGcash = () => {
    setIsOpenGcash(false);
  };
  // bpi modal
  const [isOpenBpi, setIsOpenBpi] = useState(false);
  const openModalBpi = () => {
    setIsOpenBpi(true);
  };
  const closeModalBpi = () => {
    setIsOpenBpi(false);
  };
  // maya modal
  const [isOpenMaya, setIsOpenMaya] = useState(false);
  const openModalMaya = () => {
    setIsOpenMaya(true);
  };
  const closeModalMaya = () => {
    setIsOpenMaya(false);
  };
  // metrobank modal
  const [isOpenMetrobank, setIsOpenMetrobank] = useState(false);
  const openModalMetrobank = () => {
    setIsOpenMetrobank(true);
  };
  const closeModalMetrobank = () => {
    setIsOpenMetrobank(false);
  };

  // preload images
  //gcash
  const [isImageLoadedGcash, setIsImageLoadedGcash] = useState(false);
  useEffect(() => {
    const image = new Image();
    image.src = gcash;
    image.onload = () => {
      setIsImageLoadedGcash(true);
    };
    image.style.display = 'none';
    return () => {
      image.onload = null;
    };
  }, [gcash]);
  //bpi
  const [isImageLoadedBpi, setIsImageLoadedBpi] = useState(false);
  useEffect(() => {
    const image = new Image();
    image.src = bpi;
    image.onload = () => {
      setIsImageLoadedBpi(true);
    };
    image.style.display = 'none';
    return () => {
      image.onload = null;
    };
  }, [bpi]);
  //maya
  const [isImageLoadedMaya, setIsImageLoadedMaya] = useState(false);
  useEffect(() => {
    const image = new Image();
    image.src = maya;
    image.onload = () => {
      setIsImageLoadedMaya(true);
    };
    image.style.display = 'none';
    return () => {
      image.onload = null;
    };
  }, [maya]);
  //metrobank
  const [isImageLoadedMetrobank, setIsImageLoadedMetrobank] = useState(false);
  useEffect(() => {
    const image = new Image();
    image.src = metrobank;
    image.onload = () => {
      setIsImageLoadedMetrobank(true);
    };
    image.style.display = 'none';
    return () => {
      image.onload = null;
    };
  }, [metrobank]);


  return (
    

    <ThemeProvider theme={themeData.theme === 'light' ? lightTheme : darkTheme}>
    <GlobalStyles />
    <FacebookProvider appId="1418855892064267" chatSupport>
      <CustomChat pageId="172444475943172" minimized={false}/>
    </FacebookProvider> 
    <div id='business-card'>
      <section className='business-card'>
        <div className='wrapper'>
          <div className='contact-info-container'>
            <div className='header'>

              <div className='cover-quicklink'>
                <div className='cover-bg'>
                  <svg className='cover-text-home' width="225" height="45" viewBox="0 0 225 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.86 36.225C9.61 36.225 7.585 35.715 5.785 34.695C4.015 33.675 2.62 32.265 1.6 30.465C0.58 28.665 0.0700002 26.565 0.0700002 24.165C0.0700002 21.795 0.58 19.71 1.6 17.91C2.62 16.08 4.015 14.67 5.785 13.68C7.585 12.66 9.61 12.15 11.86 12.15C13.96 12.15 15.82 12.615 17.44 13.545C19.09 14.475 20.395 15.84 21.355 17.64C22.315 19.41 22.795 21.585 22.795 24.165C22.795 26.745 22.3 28.935 21.31 30.735C20.35 32.505 19.045 33.87 17.395 34.83C15.775 35.76 13.93 36.225 11.86 36.225ZM12.085 33.39C13.765 33.39 15.265 33.015 16.585 32.265C17.935 31.485 18.985 30.405 19.735 29.025C20.515 27.615 20.905 25.995 20.905 24.165C20.905 22.335 20.515 20.73 19.735 19.35C18.985 17.97 17.935 16.89 16.585 16.11C15.265 15.33 13.765 14.94 12.085 14.94C10.435 14.94 8.95 15.33 7.63 16.11C6.31 16.89 5.26 17.97 4.48 19.35C3.7 20.73 3.31 22.335 3.31 24.165C3.31 25.995 3.7 27.615 4.48 29.025C5.26 30.405 6.31 31.485 7.63 32.265C8.95 33.015 10.435 33.39 12.085 33.39ZM20.86 44.73V28.98L21.31 24.21L20.995 19.485V12.375H24.055V44.73H20.86ZM42.718 36.225C40.708 36.225 38.953 35.85 37.453 35.1C35.953 34.35 34.783 33.225 33.943 31.725C33.133 30.225 32.728 28.35 32.728 26.1V12.375H35.923V25.74C35.923 28.26 36.538 30.165 37.768 31.455C39.028 32.715 40.783 33.345 43.033 33.345C44.683 33.345 46.108 33.015 47.308 32.355C48.538 31.665 49.468 30.675 50.098 29.385C50.758 28.095 51.088 26.55 51.088 24.75V12.375H54.283V36H51.223V29.52L51.718 30.69C50.968 32.43 49.798 33.795 48.208 34.785C46.648 35.745 44.818 36.225 42.718 36.225ZM63.1874 36V12.375H66.3824V36H63.1874ZM64.8074 7.155C64.1474 7.155 63.5924 6.93 63.1424 6.48C62.6924 6.03 62.4674 5.49 62.4674 4.86C62.4674 4.23 62.6924 3.705 63.1424 3.285C63.5924 2.835 64.1474 2.61 64.8074 2.61C65.4674 2.61 66.0224 2.82 66.4724 3.24C66.9224 3.66 67.1474 4.185 67.1474 4.815C67.1474 5.475 66.9224 6.03 66.4724 6.48C66.0524 6.93 65.4974 7.155 64.8074 7.155ZM85.0824 36.225C82.7424 36.225 80.6424 35.715 78.7824 34.695C76.9524 33.645 75.5124 32.22 74.4624 30.42C73.4124 28.59 72.8874 26.505 72.8874 24.165C72.8874 21.795 73.4124 19.71 74.4624 17.91C75.5124 16.11 76.9524 14.7 78.7824 13.68C80.6424 12.66 82.7424 12.15 85.0824 12.15C87.0924 12.15 88.9074 12.54 90.5274 13.32C92.1474 14.1 93.4224 15.27 94.3524 16.83L91.9674 18.45C91.1574 17.25 90.1524 16.365 88.9524 15.795C87.7524 15.225 86.4474 14.94 85.0374 14.94C83.3574 14.94 81.8424 15.33 80.4924 16.11C79.1424 16.86 78.0774 17.925 77.2974 19.305C76.5174 20.685 76.1274 22.305 76.1274 24.165C76.1274 26.025 76.5174 27.645 77.2974 29.025C78.0774 30.405 79.1424 31.485 80.4924 32.265C81.8424 33.015 83.3574 33.39 85.0374 33.39C86.4474 33.39 87.7524 33.105 88.9524 32.535C90.1524 31.965 91.1574 31.095 91.9674 29.925L94.3524 31.545C93.4224 33.075 92.1474 34.245 90.5274 35.055C88.9074 35.835 87.0924 36.225 85.0824 36.225ZM102.797 29.88L102.887 25.785L117.602 12.375H121.517L111.122 22.32L109.322 23.85L102.797 29.88ZM100.277 36V2.61H103.472V36H100.277ZM118.592 36L108.737 23.715L110.807 21.24L122.507 36H118.592ZM126.584 36V4.5H133.874V30.06H149.669V36H126.584ZM153.247 36V11.79H160.267V36H153.247ZM156.757 8.415C155.467 8.415 154.417 8.04 153.607 7.29C152.797 6.54 152.392 5.61 152.392 4.5C152.392 3.39 152.797 2.46 153.607 1.71C154.417 0.959998 155.467 0.584997 156.757 0.584997C158.047 0.584997 159.097 0.944998 159.907 1.665C160.717 2.355 161.122 3.255 161.122 4.365C161.122 5.535 160.717 6.51 159.907 7.29C159.127 8.04 158.077 8.415 156.757 8.415ZM181.497 11.43C183.417 11.43 185.127 11.82 186.627 12.6C188.157 13.35 189.357 14.52 190.227 16.11C191.097 17.67 191.532 19.68 191.532 22.14V36H184.512V23.22C184.512 21.27 184.077 19.83 183.207 18.9C182.367 17.97 181.167 17.505 179.607 17.505C178.497 17.505 177.492 17.745 176.592 18.225C175.722 18.675 175.032 19.38 174.522 20.34C174.042 21.3 173.802 22.53 173.802 24.03V36H166.782V11.79H173.487V18.495L172.227 16.47C173.097 14.85 174.342 13.605 175.962 12.735C177.582 11.865 179.427 11.43 181.497 11.43ZM203.7 31.05L203.88 22.5L215.175 11.79H223.545L212.7 22.815L209.055 25.785L203.7 31.05ZM197.895 36V2.61H204.915V36H197.895ZM215.94 36L207.75 25.83L212.16 20.385L224.445 36H215.94Z" fill="white"/>
                  </svg>
                </div>
              </div>

              {/* <div className='cover'>
                <img src={cover}></img>
              </div> */}

              {/* <div className='dp'>
                <img src={dp}></img>
              </div> */}

            </div>
            
            <div className='content-home'>

            <Modal isOpen={isOpenGcash} closeModal={closeModalGcash} themeData={themeData} >
              <div className='qr-code-container'>
                <span class="material-symbols-outlined close-button" onClick={closeModalGcash}>
                cancel
                </span>
                <img className='qr-code-bank' src={gcash}></img>
              </div>
            </Modal>
            <Modal isOpen={isOpenBpi} closeModal={closeModalBpi} themeData={themeData} >
              <div className='qr-code-container'>
                <span class="material-symbols-outlined close-button" onClick={closeModalBpi}>
                cancel
                </span>
                <img className='qr-code-bank' src={bpi}></img>
              </div>
            </Modal>
            <Modal isOpen={isOpenMaya} closeModal={closeModalMaya} themeData={themeData} >
              <div className='qr-code-container'>
                <span class="material-symbols-outlined close-button" onClick={closeModalMaya}>
                cancel
                </span>
                <img className='qr-code-bank' src={maya}></img>
              </div>
            </Modal>
            <Modal isOpen={isOpenMetrobank} closeModal={closeModalMetrobank} themeData={themeData} >
              <div className='qr-code-container'>
                <span class="material-symbols-outlined close-button" onClick={closeModalMetrobank}>
                cancel
                </span>
                <img className='qr-code-bank' src={metrobank}></img>
              </div>
            </Modal>

              <div className='links'>
                <span className='type'>About</span>
                <div className='each-link website'>
                    <div className='site-link home-about'>
                      <span className='about'>Crafting modern digital business cards for a world of seamless networking.</span>
                      <a onClick={() => history.push('/')}>
                        <div className='learn' >
                          <span>Learn More</span>
                        </div>
                      </a>
                    </div>
                </div>
              </div>

              <div className='links'>
                <span className='type'>Account Settings</span>
                {/* <a href='https://forms.gle/E8LZmXSGgSpRVB9v9'>
                  <div className='each-link website'>
                      <div className='site-link'>
                        <span>Activate Card</span>
                        <span class="material-symbols-outlined">
                        check_circle
                        </span>
                      </div>
                  </div>
                </a> */}
                {/* <a href=''> */}

                  {/* update profile with payment */}

                  {/* <div className='each-link website'>
                      <div className='site-link'  onClick={toggleVisibility1}>
                        <span>Update Profile</span>
                        <motion.span class="material-symbols-outlined"
                         onClick={toggleVisibility1}
                         initial={{ rotate: 0 }}
                         animate={{ rotate: isVisible1 ? 360 : 0 }}
                         transition={{ duration: 0.3 }}
                        >
                        update
                        </motion.span>
                      </div>
                      <motion.div className='more-actions'
                       initial={{ opacity: 0, y: -10, height: 0, display: "none" }}
                       animate={{
                         opacity: isVisible1 ? 1 : 0,
                         y: isVisible1 ? 0 : -10,
                         height: isVisible1 ? "auto" : 0,
                         display: isVisible1 ? "block" : "none",
                       }}
                       transition={{ type: 'spring', stiffness: 100, duration: 0.5 }}
                      >
                        <span> <strong>Please note that 100 PHP processing fee applies for information updates, covering checks for compliance and security against malicious content.</strong></span>
                        <a className='site-link sub' onClick={openModalGcash}>
                          <span>GCash</span>
                          <span class="material-symbols-outlined">
                          qr_code
                          </span>
                        </a>
                        <a className='site-link sub' onClick={openModalMaya}>
                          <span>Maya</span>
                          <span class="material-symbols-outlined">
                          qr_code
                          </span>
                        </a>
                        <a className='site-link sub' onClick={openModalBpi}>
                          <span>BPI</span>
                          <span class="material-symbols-outlined">
                          qr_code
                          </span>
                        </a>
                        <a className='site-link sub' onClick={openModalMetrobank}>
                          <span>Metrobank</span>
                          <span class="material-symbols-outlined">
                          qr_code
                          </span>
                        </a>

                        <div className='hr-home'></div>

                        <a href='https://forms.gle/2LTe9q2G9ZnkVdXq8'>
                          <div className='site-link sub update'>
                            <span>Proceed to Update</span>
                            <span class="material-symbols-outlined">
                            arrow_circle_right
                            </span>
                          </div>
                        </a>
                      </motion.div>
                  </div> */}

                  {/* update profile for free */}

                  <div className='each-link website'>
                      <div className='site-link'  onClick={toggleVisibility1}>
                        <span>Update Profile</span>
                        <motion.span class="material-symbols-outlined"
                         onClick={toggleVisibility1}
                         initial={{ rotate: 0 }}
                         animate={{ rotate: isVisible1 ? 360 : 0 }}
                         transition={{ duration: 0.3 }}
                        >
                        update
                        </motion.span>
                      </div>
                      <motion.div className='more-actions'
                       initial={{ opacity: 0, y: -10, height: 0, display: "none" }}
                       animate={{
                         opacity: isVisible1 ? 1 : 0,
                         y: isVisible1 ? 0 : -10,
                         height: isVisible1 ? "auto" : 0,
                         display: isVisible1 ? "block" : "none",
                       }}
                       transition={{ type: 'spring', stiffness: 100, duration: 0.5 }}
                      >
                        <span> <strong>Please note that your profile update is subject to checks for compliance and security against malicious content. Kindly wait for few minutes for changes to reflect.</strong></span>

                        <a href='https://forms.gle/2LTe9q2G9ZnkVdXq8'>
                          <div className='site-link sub update'>
                            <span>Proceed to Update</span>
                            <span class="material-symbols-outlined">
                            arrow_circle_right
                            </span>
                          </div>
                        </a>
                      </motion.div>
                  </div>
                {/* </a> */}
                {/* <a href=''> */}
                  <div className='each-link website'>
                      <div className='site-link'  onClick={toggleVisibility2}>
                        <span>Deactivate Card</span>
                        <motion.span class="material-symbols-outlined"
                         onClick={toggleVisibility2}
                         initial={{ rotate: 0 }}
                         animate={{ rotate: isVisible2 ? 360 : 0 }}
                         transition={{ duration: 0.3 }}
                        >
                        block
                        </motion.span>
                      </div>
                      <motion.div className='more-actions'
                       initial={{ opacity: 0, y: -10, height: 0, display: "none" }}
                       animate={{
                         opacity: isVisible2 ? 1 : 0,
                         y: isVisible2 ? 0 : -10,
                         height: isVisible2 ? "auto" : 0,
                         display: isVisible2 ? "block" : "none",
                       }}
                       transition={{ type: 'spring', stiffness: 100, duration: 0.5 }}
                      >
                        <span> <strong>Please be informed that deactivation is irreversible. You will have to get a new card and register a new profile when you wish to use quickLink again.</strong></span>
                        
                        <a href='https://forms.gle/mZLPNWj2GTM6Lc1c6'>
                          <div className='site-link sub deactivate'>
                            <span>Proceed to Deactivate</span>
                            <span class="material-symbols-outlined">
                            arrow_circle_right
                            </span>
                          </div>
                        </a>
                      </motion.div>
                  </div>
                {/* </a> */}
              </div>

              <div className='links'>
                <span className='type'>Profile Demo</span>
                <a target="_blank" rel="noopener noreferrer" href="https://quick-link.info/test">
                  <div className='each-link website'>
                      <div className='site-link'>
                        <span>QuickLink <b>Standard</b></span>
                        <span class="material-symbols-outlined">
                        account_circle
                        </span>
                      </div>
                  </div>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://quick-link.info/test-pro">
                  <div className='each-link website'>
                      <div className='site-link'>
                        <span>QuickLink <b>PRO</b></span>
                        <svg className='blue-check' height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.22917 17.5L4.66667 14.9167L1.72917 14.25L2 11.25L0 9L2 6.75L1.72917 3.75L4.66667 3.08333L6.22917 0.5L9 1.6875L11.7708 0.5L13.3333 3.08333L16.2708 3.75L16 6.75L18 9L16 11.25L16.2708 14.25L13.3333 14.9167L11.7708 17.5L9 16.3125L6.22917 17.5ZM7.9375 12L12.8958 7.0625L11.8333 6L7.9375 9.875L6.16667 8.125L5.10417 9.1875L7.9375 12Z"/>
                        </svg>
                      </div>
                  </div>
                </a>
              </div>

              <div className='links'>
                <span className='type'>Contact Us</span>
                <a href='mailto:quicklink.tag@gmail.com'>
                  <div className='each-link website'>
                      <div className='site-link'>
                        <span>Email</span>
                        <span class="material-symbols-outlined">
                        alternate_email
                        </span>
                      </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
    
    </ThemeProvider>
  );
}

export default Home;